<template>
<div class="tab-container no-print">
  <div class="tabs is-small is-centered">
    <ul>
      <li v-for="tab in filteredTabs"
          :key="tab.name"
          :class="{'is-active': activeTab === tab.name, 'not-active' : activeTab !== tab.name}"
          @click="setActiveTab(tab.name)"
          tabindex="0"
          @keypress.space.enter="setActiveTab(tab.name)"
          :qa="tab.name">
        <a v-if="tab.name === 'search'"
           class="tab-content is-uppercase"
           :class="'gtm-project-view-'+ tab.name.toLowerCase()"
           v-html="tab.label" />
        <a v-else class="tab-content is-uppercase"
           :class="'gtm-project-view-'+ tab.name.toLowerCase()">
          {{ $t(tab.label) }}
        </a>
        <span v-if="true" data-balloon-visible
              :data-balloon="tab.text"
              :data-balloon-pos="tab.position"
              data-balloon-length="medium"
              class="mobile-tooltip" />
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import displayTypes from '@/mixins/project-display-types'

import state from '../state'

export default {
  mixins: [auth, componentState, displayTypes],
  props: ['startTab', 'isSaved'],
  data: function () {
    return {
      tabs: [
        { name: 'search', label: '<i class="fal fa-search" style="line-height: 18px;"></i>', text: 'Dolor sit', position: 'down' },
        { name: 'list', label: 'projectPage.listView', text: 'Lorem ipsum', position: 'down' },
        { name: 'grid', label: 'projectPage.gridView', text: 'Dolor sit', position: 'down' },
        { name: 'linked', label: 'projectPage.linkedProjects', text: 'Dolor sit', position: 'down' },
        { name: 'chat', label: 'projectPage.teamChat', text: 'Dolor sit', position: 'down' },
        { name: 'liveChat', label: 'projectPage.liveChat', text: 'Dolor sit', position: 'down' },
        { name: 'results', label: 'projectPage.results', text: 'Dolor sit', position: 'down' }
      ]
    }
  },
  mounted: function () {
    if (this.startTab !== 'list') {
      this.setActiveTab(this.startTab)
    }
    if (this.$route.name === 'viewStory') {
      this.tabs[2].label = 'Linked Stories'
    }
  },
  computed: {
    activeTab: function () {
      return this._get(state.activeTab)
    },
    filteredTabs: function () {
      let filteredTabs = this.tabs
      filteredTabs = this.tabs.filter((tab) => tab.name !== 'linked')
      const memberData = this.$store.getters.membership(this._get(state.project.id), this.currentUser.uuid)
      const currentMemberRole = memberData ? memberData.role : ''
      if (!this.canViewChat) {
        filteredTabs = this.tabs.filter((tab) => tab.name !== 'chat')
      }
      if (!this.$isBroadcomMasters && !this.$isAjas) {
        filteredTabs = this.tabs.filter((tab) => tab.name !== 'liveChat')
      }
      if (this.projectType === this.DisplayTypeRegistrationForm) {
        filteredTabs = this.tabs.filter((tab) => !['liveChat', 'chat', 'linked', 'search'].includes(tab.name))
      }
      if (!this.isLoggedIn) {
        filteredTabs = this.tabs.filter((tab) => tab.name !== 'results')
      } else if (this.currentUser.isJudgingAdmin === false) {
        if (currentMemberRole !== 'resultsViewer' && currentMemberRole !== 'admin') {
          filteredTabs = this.tabs.filter((tab) => tab.name !== 'results')
        }
      }
      if (!this.isLoggedIn) {
        filteredTabs = this.tabs.filter((tab) => !['liveChat', 'chat', 'results'].includes(tab.name))
      }
      if (this.projectType === this.DisplayTypeRegistrationForm) {
        filteredTabs = this.tabs.filter((tab) => !['liveChat', 'chat', 'linked', 'search', 'results'].includes(tab.name))
      }
      filteredTabs = filteredTabs.filter((tab) => !['linked', 'results'].includes(tab.name))
      return filteredTabs
    },
    canViewChat: function () {
      return this._get(state.project.permissions.chat, false)
    },
    projectType: function () {
      return this._get(state.project.displayType, this.DisplayTypeProject)
    }
  },
  methods: {
    setActiveTab: function (tab) {
      this._set(state.activeTab, tab)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.tab-container {
  border-top: 20px solid #F2F2F2;
  padding-top: .75rem;
  position: absolute;
  max-width: 800px;
  text-align: center;
  width: 100%;
  background-color: white;
}

.tabs {
  font-family: 'Roboto';
  font-weight: normal;
  color: #9b9b9b;
  border: none;
  ul {
    border-bottom: 0;
    a {
      border: none;
      margin-bottom: 1px;
      padding: 0.5rem 0.75rem;
      @media (max-width: 410px) {
        padding: 0.5rem 0.5rem;
      }
      @media (max-width: 365px) {
        padding: 0.5rem 0.4rem;
        font-size: 0.72rem !important;
      }
      @media (max-width: 340px) {
        padding: 0.5rem 0.2rem;
      }
    }
    a {
      &:hover {
        border-bottom: 1px solid #9b9b9b;
        margin-bottom: 0;
      }
    }
    .is-active {
      a {
        margin-bottom: 0;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid $primary;
      }
    }
    .not-active {
      &:focus {
        border: 1px solid $primary;
      }
    }
  }
}

.tab-container {
  padding-top: 2.6rem;
}

</style>
